import { render, staticRenderFns } from "./PgaPartialContent.vue?vue&type=template&id=60b33abc&"
import script from "./PgaPartialContent.vue?vue&type=script&lang=ts&"
export * from "./PgaPartialContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b33abc')) {
      api.createRecord('60b33abc', component.options)
    } else {
      api.reload('60b33abc', component.options)
    }
    module.hot.accept("./PgaPartialContent.vue?vue&type=template&id=60b33abc&", function () {
      api.rerender('60b33abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaPartialContent.vue"
export default component.exports